// import CSS stays the same
import "./aggregate-skill-gaps-report.css"

// Short Report: Aggregate Skill Gaps (Department vs Department)
const AggregateSkillGapsReport = (props) => {
  // Prefer the actual prop from parent, but keep fallbacks for safety
  const comparisonResult = props?.comparisonData ?? props?.comparisonResult ?? null;

  console.log("Aggregate Skill Gaps Comparison Result:", comparisonResult)

  // pull from API shape
  const data = comparisonResult?.skillGapsShortReport || {}
  const deptDetails = comparisonResult?.detailedReport?.departmentDetails || {}
  const deptAName = deptDetails?.deptA?.name || "Department A"
  const deptBName = deptDetails?.deptB?.name || "Department B"

  const aSoft = Number(data.deptAAvgSoftSkillGap ?? 0)
  const bSoft = Number(data.deptBAvgSoftSkillGap ?? 0)
  const aHard = Number(data.deptAAvgHardSkillGap ?? 0)
  const bHard = Number(data.deptBAvgHardSkillGap ?? 0)

  const clamp = (v) => Math.max(0, Math.min(100, isFinite(v) ? v : 0))

  return (
    <div className="dd-asg-short-report-container">
      <div className="dd-asg-report-header">
        <h3>Aggregate Skill Gaps</h3>
        <p>Understanding skill deficiencies at departmental level for L&amp;D planning</p>
      </div>

      <div className="dd-asg-comparison-summary">
        {/* Soft skills */}
        <div className="dd-asg-summary-card">
          <div className="dd-asg-summary-icon">
            {/* icon */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="dd-asg-summary-content">
            <div className="dd-asg-summary-value">{`${Number(aSoft).toFixed(2)}%`}</div>
            <div className="dd-asg-summary-label">{`Soft Skill Gaps - ${deptAName}`}</div>
          </div>
        </div>

        <div className="dd-asg-summary-card">
          <div className="dd-asg-summary-icon">
            {/* icon */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="dd-asg-summary-content">
            <div className="dd-asg-summary-value">{`${Number(bSoft).toFixed(2)}%`}</div>
            <div className="dd-asg-summary-label">{`Soft Skill Gaps - ${deptBName}`}</div>
          </div>
        </div>

        {/* Hard skills */}
        <div className="dd-asg-summary-card">
          <div className="dd-asg-summary-icon">
            {/* icon */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="dd-asg-summary-content">
            <div className="dd-asg-summary-value">{`${Number(aHard).toFixed(2)}%`}</div>
            <div className="dd-asg-summary-label">{`Hard Skill Gaps - ${deptAName}`}</div>
          </div>
        </div>

        <div className="dd-asg-summary-card">
          <div className="dd-asg-summary-icon">
            {/* icon */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="dd-asg-summary-content">
            <div className="dd-asg-summary-value">{`${Number(bHard).toFixed(2)}%`}</div>
            <div className="dd-asg-summary-label">{`Hard Skill Gaps - ${deptBName}`}</div>
          </div>
        </div>
      </div>

      {/* Skill Gap Comparison Metrics */}
      <div className="dd-asg-metrics-comparison">
        <h3>Soft Skill Gap Percentage Comparison</h3>
        <div className="dd-asg-metrics-chart">
          <div className="dd-asg-metric-bar-container">
            <div className="dd-asg-metric-info">
              <span className="dd-asg-metric-name">Soft Skill Gaps</span>
              <span className="dd-asg-metric-name" style={{ fontWeight: "400" }}>
                {deptAName}
              </span>
            </div>
            <div className="dd-asg-metric-bar">
              <div className="dd-asg-metric-fill" style={{ width: `${clamp(aSoft)}%` }} />
              <span className="dd-asg-metric-value">{`${Number(aSoft).toFixed(2)}%`}</span>
            </div>
          </div>

          <div className="dd-asg-metric-bar-container">
            <div className="dd-asg-metric-info">
              <span className="dd-asg-metric-name">Soft Skill Gaps</span>
              <span className="dd-asg-metric-name" style={{ fontWeight: "400" }}>
                {deptBName}
              </span>
            </div>
            <div className="dd-asg-metric-bar">
              <div className="dd-asg-metric-fill" style={{ width: `${clamp(bSoft)}%` }} />
              <span className="dd-asg-metric-value">{`${Number(bSoft).toFixed(2)}%`}</span>
            </div>
          </div>

          <h3 style={{ marginBottom: "0px" }}>Hard Skill Gap Percentage Comparison</h3>

          <div className="dd-asg-metric-bar-container">
            <div className="dd-asg-metric-info">
              <span className="dd-asg-metric-name">Hard Skill Gaps</span>
              <span className="dd-asg-metric-name" style={{ fontWeight: "400" }}>
                {deptAName}
              </span>
            </div>
            <div className="dd-asg-metric-bar">
              <div className="dd-asg-metric-fill" style={{ width: `${clamp(aHard)}%` }} />
              <span className="dd-asg-metric-value">{`${Number(aHard).toFixed(2)}%`}</span>
            </div>
          </div>

          <div className="dd-asg-metric-bar-container">
            <div className="dd-asg-metric-info">
              <span className="dd-asg-metric-name">Hard Skill Gaps</span>
              <span className="dd-asg-metric-name" style={{ fontWeight: "400" }}>
                {deptBName}
              </span>
            </div>
            <div className="dd-asg-metric-bar">
              <div className="dd-asg-metric-fill" style={{ width: `${clamp(bHard)}%` }} />
              <span className="dd-asg-metric-value">{`${Number(bHard).toFixed(2)}%`}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="dd-asg-insights-section">
        <h3>Analysis Overview</h3>
        <div className="dd-asg-analysis-paragraph">
          <p>{data?.overview || "No analysis available."}</p>
        </div>
      </div>
    </div>
  )
}

export default AggregateSkillGapsReport
